module.exports = __webpack_public_path__ + "static/media/box_plot_image.bbb9e520.png";